import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitScoreConfigTask extends Task {
    constructor(assetLibrary, scoreConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const scoreJson = assetLibrary.getAsset("score-config");
            scoreConfig.setPropertiesFromObject(scoreJson);

            callback(this);
        }
    }
}